import * as z from 'zod';

export interface Mounting extends z.infer<typeof MountingRuntype> {}
export const MountingRuntype = z.object({
    name: z.union([z.literal('SMT'), z.literal('THT')]),
});
